import React from 'react';
import {
  Home,
  FileText,
  RefreshCw,
  Users,
  FileBox,
  Trash2,
  History,
  LogOut,
  X
} from 'lucide-react';
import { NavLink } from 'react-router-dom';

export const navItems = [
  { name: 'Издаване', icon: FileText, path: '/test-new-form', id: 'issue' },
  { name: 'Автоматични', icon: RefreshCw, path: '/test-automatic', id: 'recurring' },
  { name: 'Клиенти', icon: Users, path: '/test-clients', id: 'clients' },
  { name: 'Проформа', icon: FileBox, path: '/test-proforma', id: 'preinvoices' },
  { name: 'Изтрити', icon: Trash2, path: '/test-deleted', id: 'deleted' },
  { name: 'История', icon: History, path: '/test-history', id: 'history' },
];

const Sidebar = ({ isOpen, onClose, tenantName = 'Издаване на фактура', currentView, onNavigate }) => {
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-900/50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar container */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-[260px] bg-white h-screen flex flex-col border-r border-gray-100 
        transform transition-transform duration-300 ease-in-out
        lg:translate-x-0 lg:sticky lg:top-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        {/* Header */}
        <div className="p-4 flex items-center justify-between">
          <h1 className="text-[20px] font-bold text-gray-900 tracking-tight px-4 mt-2 mb-2 truncate max-w-[200px]">{tenantName}</h1>
          <button
            onClick={onClose}
            className="lg:hidden p-2 text-gray-500 hover:bg-gray-100 rounded-md"
          >
            <X size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 space-y-2 mt-4">
          {navItems.map((item) => {
            const Icon = item.icon;

            if (onNavigate) {
              const isActive = currentView === item.id;
              return (
                <button
                  key={item.name}
                  onClick={() => onNavigate(item.id)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-colors ${isActive
                      ? 'bg-tenant-primary text-white'
                      : 'text-gray-600 hover:bg-gray-50'
                    }`}
                >
                  <Icon size={18} strokeWidth={2} />
                  {item.name}
                </button>
              );
            }

            return (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-colors ${isActive
                    ? 'bg-tenant-primary text-white'
                    : 'text-gray-600 hover:bg-gray-50'
                  }`
                }
              >
                <Icon size={18} strokeWidth={2} />
                {item.name}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
